"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiLeadIngressResponseSchema = exports.apiLeadIngressRequestSchema = exports.leadChannelIngressResponseSchema = exports.leadChannelIngressPayloadV1Schema = exports.leadChannelPreferredScheduleSchema = exports.leadChannelServiceRequestSchema = exports.leadChannelMutationResponseSchema = exports.leadChannelConnectionOperationSchema = exports.configureLeadChannelRequestSchema = exports.leadChannelListResponseSchema = exports.leadChannelSchema = exports.leadChannelHealthSchema = exports.leadChannelCapabilitySchema = exports.leadChannelStatusSchema = exports.leadChannelAuthMethodSchema = exports.leadChannelKindSchema = exports.leadChannelKeySchema = void 0;
const zod_1 = require("zod");
const job_inbox_1 = require("./job-inbox");
const google_lsa_1 = require("./google-lsa");
/**
 * Stable keys for intake paths that can create Job Inbox work. Lead channels
 * describe transport/configuration. They are intentionally separate from
 * attribution sources such as Referral or Campaign.
 */
exports.leadChannelKeySchema = zod_1.z.enum([
    "ONLINE_BOOKING",
    "LEAD_FORM",
    "WEBSITE_CHAT",
    "GOOGLE_BUSINESS_PROFILE",
    "GOOGLE_LOCAL_SERVICES",
    "ANGI",
    "THUMBTACK",
    "ELOCAL",
    "API",
]);
exports.leadChannelKindSchema = zod_1.z.enum(["NATIVE", "EXTERNAL", "API"]);
exports.leadChannelAuthMethodSchema = zod_1.z.enum([
    "NONE",
    "OAUTH2",
    "WEBHOOK_SECRET",
    "API_KEY",
]);
exports.leadChannelStatusSchema = zod_1.z.enum([
    "ACTIVE",
    "NOT_CONNECTED",
    "CONNECTED",
    "DISABLED",
    "NEEDS_ATTENTION",
]);
exports.leadChannelCapabilitySchema = zod_1.z.enum([
    "RECEIVE_REQUESTS",
    "TWO_WAY_MESSAGES",
    "DELIVERY_STATUS",
    "AUTO_REPLY",
]);
exports.leadChannelHealthSchema = zod_1.z.object({
    lastReceivedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastCheckedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastErrorAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastErrorCode: zod_1.z.string().max(120).nullable(),
});
exports.leadChannelSchema = zod_1.z.object({
    key: exports.leadChannelKeySchema,
    displayName: zod_1.z.string().trim().min(1).max(120),
    description: zod_1.z.string().trim().min(1).max(300),
    kind: exports.leadChannelKindSchema,
    authMethod: exports.leadChannelAuthMethodSchema,
    status: exports.leadChannelStatusSchema,
    capabilities: zod_1.z.array(exports.leadChannelCapabilitySchema),
    configurable: zod_1.z.boolean(),
    connectionId: zod_1.z.string().uuid().nullable(),
    health: exports.leadChannelHealthSchema,
    googleLsa: google_lsa_1.googleLsaLeadChannelSummarySchema.optional(),
});
exports.leadChannelListResponseSchema = zod_1.z.object({
    channels: zod_1.z.array(exports.leadChannelSchema),
});
exports.configureLeadChannelRequestSchema = zod_1.z
    .object({
    secret: zod_1.z.string().trim().min(24).max(512),
})
    .strict();
exports.leadChannelConnectionOperationSchema = zod_1.z.enum([
    "enable",
    "disable",
]);
exports.leadChannelMutationResponseSchema = zod_1.z.object({
    success: zod_1.z.literal(true),
});
exports.leadChannelServiceRequestSchema = zod_1.z.object({
    title: zod_1.z.string().trim().min(1).max(160),
    summary: zod_1.z.string().trim().max(2_000).nullable(),
    category: zod_1.z.string().trim().max(120).nullable().default(null),
});
exports.leadChannelPreferredScheduleSchema = zod_1.z
    .object({
    startAt: zod_1.z.string().datetime({ offset: true }),
    endAt: zod_1.z.string().datetime({ offset: true }),
})
    .refine((value) => new Date(value.startAt).getTime() < new Date(value.endAt).getTime(), { path: ["endAt"], message: "endAt must be after startAt." });
/**
 * Canonical v1 provider envelope. tenantId and businessId never arrive in the
 * payload: the server resolves them from the scoped connection credential.
 */
exports.leadChannelIngressPayloadV1Schema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal("1"),
    externalSourceId: zod_1.z.string().trim().min(1).max(255),
    receivedAt: zod_1.z.string().datetime({ offset: true }),
    contact: job_inbox_1.jobInboxContactSchema,
    serviceRequest: exports.leadChannelServiceRequestSchema,
    serviceAddress: job_inbox_1.jobInboxServiceAddressSchema.nullable(),
    attribution: job_inbox_1.jobInboxAttributionSchema.nullable(),
    preferredSchedule: exports.leadChannelPreferredScheduleSchema
        .nullable()
        .default(null),
    safeMetadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).default({}),
})
    .strict();
exports.leadChannelIngressResponseSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    duplicate: zod_1.z.boolean(),
    itemId: zod_1.z.string().uuid(),
});
/**
 * Public API leads use the same canonical request shape as provider adapters.
 * Scope is resolved from the connection credential, never from request data.
 */
exports.apiLeadIngressRequestSchema = exports.leadChannelIngressPayloadV1Schema;
exports.apiLeadIngressResponseSchema = exports.leadChannelIngressResponseSchema;
//# sourceMappingURL=lead-channel.js.map